import PropTypes from 'prop-types';
import React from "react";
import EventCell from "./EventCell";
import moment from "moment";
import _ from "lodash";

export default class EventCellPredictor extends EventCell {
    static contextTypes = {
        info: PropTypes.object,
        screenSizeObserver: PropTypes.object,
        teamLogoSettings: PropTypes.object,
        handleClickPrediction: PropTypes.func,
        predictions: PropTypes.array
    };

    renderCellInfo () {
        return null;
    }

    getPreliveStatus (event) {
        return moment(event.startDate).format('DD. MMM');
    }

    renderExtraContent(event) {
        if (event.statusType === 'finished') return null;

        let {handleClickPrediction, predictions} = this.context;
        let predictionForThisEvent = _.find(predictions, {eventId: event.eventId});
        let outcome = predictionForThisEvent && predictionForThisEvent.outcome;

        return (
            <div className="wdp-event-cell__predict-buttons">
                <button
                    onClick={(e) => handleClickPrediction(e, event, 'home')}
                    className={`wdp-btn wdp-btn-default ${outcome === 'home' ? 'wdp-btn-success' : ""}`}
                >1</button>
                <button
                    onClick={(e) => handleClickPrediction(e, event, 'draw')}
                    className={`wdp-btn wdp-btn-default ${outcome === 'draw' ? 'wdp-btn-success' : ""}`}
                >X</button>
                <button
                    onClick={(e) => handleClickPrediction(e, event, 'away')}
                    className={`wdp-btn wdp-btn-default ${outcome === 'away' ? 'wdp-btn-success' : ""}`}
                >2</button>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/EventCellPredictor.js
 **/